// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".widget-tabs {\n  padding: 0 3px;\n}\n.widget-tab-container ul[role=tablist] {\n  display: none;\n}\n.loading {\n  height: 144px;\n  margin-left: calc(50% - 16px);\n  margin-top: calc(25% - 16px);\n}\n", ""]);
// Exports
module.exports = exports;
